import { useCallback } from 'react'
import axios from 'axios'
import { trackPromise } from 'react-promise-tracker'
import { useAuthStore } from '../../store/useStore'
export const useFetch = () => {
  const token = useAuthStore((state) => state.bearer)

  const fetchData = useCallback(
    async (method, url, options = {}) => {
      const { postData, enableTrackPromise, headers } = options
      const isFormData = postData

      const headerObject = isFormData
        ? {
            Accept: '*/*',
            Authorization: headers?.Authorization || `Bearer ${token}`,
          }
        : {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: headers?.Authorization || `Bearer ${token}`,
          }

      const axiosConfig = {
        method,
        url,
        headers: headerObject,
        data: postData,
      }

      const fetchPromise = axios(axiosConfig)
        .then((response) => response)
        .catch((err) =>
          err && typeof err === 'object' && 'response' in err
            ? err.response
            : err
        )

      return enableTrackPromise
        ? await trackPromise(fetchPromise)
        : await fetchPromise
    },
    [token]
  )

  return { fetchData }
}
